export function encodeAddress(address) {
  const text = String(address || "").trim();
  if (!text) return "";
  if (
    /available on request|coming soon|to be announced|details available soon|shared for sunday guests|schedule being finalized/i.test(
      text
    )
  ) {
    return "";
  }
  return encodeURIComponent(text);
}

export function isAppleMobileDevice(userAgent = "") {
  const ua =
    userAgent || (typeof navigator !== "undefined" ? navigator.userAgent || "" : "");

  return /iPhone|iPad|iPod/i.test(ua);
}

export function getMapsUrl(address, userAgent = "") {
  const encoded = encodeAddress(address);
  if (!encoded) return null;

  if (isAppleMobileDevice(userAgent)) {
    return `http://maps.apple.com/?q=${encoded}`;
  }

  return `https://www.google.com/maps/search/?api=1&query=${encoded}`;
}

export function openMapsAddress(address) {
  const url = getMapsUrl(address);
  if (!url || typeof window === "undefined") return false;

  window.open(url, "_blank", "noopener,noreferrer");
  return true;
}
